import http from './request'
// import parse from 'mini-html-parser2'
import {
  isWeb,
  isMiniProgram,
  isAliProgram,
  isPassenger,
  isWeixinH5,
  isQQH5,
  isAliH5,
  isAliProgramH5,
  isMiniProgramH5,
} from './env'
import mpx from '@mpxjs/core'
import store from '../../store'
import {
  query as webxQuery,
  hashQuery,
  build,
  bridge,
  login as webxLogin,
  isLogin as webxIsLogin,
  logout as webxLogout,
  isHK,
  is,
  compareVersion,
} from '@didi/webx-js'
import { HKDomainConvert } from './hk_url'
import { GlobalEnv } from '../webx'
import { EnumLang } from '../webx/defines'
import { normalizeLoginInfo } from './token-guard'
import { MASErrorTrackTransformUrl } from '../webx/mas_error_track'

export function formatFen2Yuan(fen) {
  return fen === 0 ? fen : Math.round(fen * 100) / 10000
}

function nullFn() {}

export function setTicket(token, success = nullFn, fail = nullFn) {
  const sdk = window.login
  if (sdk && sdk.setTicket) {
    sdk.setTicket?.(
      token,
      res => {
        success(res)
      },
      err => {
        fail(err)
      }
    )
  } else {
    fail({ errno: -1, errmsg: '登录sdk加载问题，请检查网络' })
  }
}

function leftFillNum(num, targetLength = 0) {
  const str = num.toString()
  const len = str.length
  let fill = ''
  while (len < targetLength) {
    fill += '0'
    targetLength--
  }
  return fill + str
}

export function parseTime(_date) {
  let dateObj = null
  dateObj = typeof _date !== 'object' ? new Date(parseInt(_date)) : _date
  const month = dateObj.getMonth() + 1
  const date = dateObj.getDate()
  const hour = dateObj.getHours()
  const minute = dateObj.getMinutes()
  const seconds = dateObj.getSeconds()

  return {
    year: dateObj.getFullYear(),
    month: leftFillNum(month, 2),
    date: leftFillNum(date, 2),
    hour: leftFillNum(hour, 2),
    minute: leftFillNum(minute, 2),
    seconds: leftFillNum(seconds, 2),
    day: dateObj.getDay(),
    millisec: dateObj.getTime(),
  }
}

export function parseClock(time) {
  const h = parseInt(time / 1000 / 60 / 60)
  const m = parseInt((time / 1000 / 60) % 60)
  const s = parseInt((time / 1000) % 60)
  return {
    h: leftFillNum(h, 2),
    m: leftFillNum(m, 2),
    s: leftFillNum(s, 2),
  }
}

export function throttle(fun, wait) {
  let timer = null
  return function (...args) {
    if (!timer) {
      timer = setTimeout(() => {
        fun.apply(this, args)
        timer = null
      }, wait)
    }
  }
}

export function preloadImage(url, delay) {
  setTimeout(() => {
    if (isWeb()) {
      new window.Image(0, 0).src = url
    } else if (isMiniProgram()) {
      wx.getImageInfo({ src: url })
    } else if (isAliProgram()) {
      my.getImageInfo({ src: url })
    }
  }, delay)
}

// 自己加的
export function login() {
  return new Promise((resolve, reject) => {
    webxLogin()
      .then(res => {
        const loginInfo = normalizeLoginInfo(res)
        if (loginInfo.token) {
          try {
            window.Omega?.setConfig?.({ forbidReport: false })
          } catch (error) {}
        }
        resolve(loginInfo)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function isLogin() {
  return new Promise((resolve, reject) => {
    webxIsLogin()
      .then(res => {
        const loginInfo = normalizeLoginInfo(res)
        if (loginInfo.token) {
          try {
            window.Omega?.setConfig?.({ forbidReport: false })
          } catch (error) {}
        }
        resolve(loginInfo)
      })
      .catch(e => {
        reject(e)
      })
  })
}

export function logout() {
  return new Promise((resolve, reject) => {
    webxLogout().then(res => {
      try {
        window.Omega?.setConfig?.({ forbidReport: true })
      } catch (error) {}
      resolve()
    })
  })
}

// export function htmlToNodes(html) {
//   return new Promise((resolve, reject) => {
//     parse(html, (err, nodes) => {
//       if (err) {
//         reject(err)
//       } else {
//         resolve(nodes)
//       }
//     })
//   })
// }

export function getOpenIdRedirect(openid) {
  if ((isQQH5() || isAliH5() || isWeixinH5()) && !openid) {
    const oidPath =
      'https://common.diditaxi.com.cn/webapp/platform/oauth2/openid?redirect=' +
      encodeURIComponent(
        encodeURIComponent(encodeURIComponent(window.location.href))
      )
    window.location.replace(HKDomainConvert(oidPath, isHK))
  }
}

export function formatEventParams(eventParams) {
  if (!eventParams) {
    return {}
  }
  eventParams = decodeURIComponent(eventParams)
  const _paramsArr = eventParams.split('|')
  const _paramsObj = {}
  _paramsArr.forEach(item => {
    const _arr = item.split(':')
    const key = _arr[0] + ''
    const value = _arr[1]
    _paramsObj[key] = value
  })
  return _paramsObj
}

export function joinEventParams(eventParams) {
  const _paramsArray = []
  eventParams &&
    Object.keys(eventParams).forEach(key => {
      _paramsArray.push(`${key}:${eventParams[key]}`)
    })
  return _paramsArray.join('|')
}

export function sendRecOrderRequest(eventParams, eventUrl) {
  if (store.getters.userInfo.token) {
    eventUrl = HKDomainConvert(
      'https://winter-campaign.xiaojukeji.com/strategy-genrec/biztech_arch/strategygenrec/event',
      isHK
    )
    http
      .get(eventUrl, eventParams)
      .then(() => {})
      .catch(() => {})
  }
}

export function setTitle(title) {
  isPassenger()
    ? bridge.setTitle(title)
    : mpx.setNavigationBarTitle({
        title: title,
      })
}

// 获取风控所需数据
export async function getServerEnv(isHitButton = false, isOpenWeb = true) {
  //  重灾区
  // http://newton.intra.xiaojukeji.com/thor/avatar-document/6e820aa58f61444c879a205842465c34?env=1#example
  const { cityInfo, userInfo } = store.state
  // appid // http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=115044079
  const env = {
    newTicket: userInfo && userInfo.token,
    latitude: String((cityInfo && cityInfo.lat) || ''),
    longitude: String((cityInfo && cityInfo.lng) || ''),
    userAgent: String((window.navigator && window.navigator.userAgent) || ''),
    cityId: String((cityInfo && cityInfo.cityId) || ''),
  }
  if (isPassenger()) {
    const query = Object.assign({}, webxQuery(), hashQuery())
    let systemInfo = {}
    await getSystemInfo().then(res => {
      systemInfo = res
    })
    // 乘客端 newAppid: 39013
    Object.assign(env, {
      fromChannel: '1',
      ddfp: systemInfo.imei || '',
      deviceId: String(systemInfo.deviceId || systemInfo.deviceid || ''),
      appVersion: String(query.appVersion || query.appversion || ''),
    })
  } else if (isMiniProgram()) {
    // wx原生 newAppid: 35009
    Object.assign(env, {
      fromChannel: '2',
      openIdType: '1',
    })
  } else if (isMiniProgramH5()) {
    // 微信内嵌H5 newAppid: 30005
    Object.assign(env, {
      fromChannel: '2',
    })
  } else if (isWeixinH5()) {
    // 微信h5 newAppid: 30004
    Object.assign(env, {
      fromChannel: '2',
    })
  } else if (isAliProgram()) {
    // 支付宝原生 newAppid: 35023,
    Object.assign(env, {
      fromChannel: '3',
      openIdType: '2',
    })
  } else if (isAliH5()) {
    // 支付宝h5 newAppid: 30004
    Object.assign(env, {
      fromChannel: '3',
    })
  } else if (isAliProgramH5()) {
    // 支付宝内嵌H5 newAppid: 30001
    Object.assign(env, {
      fromChannel: '3',
    })
  } else if (isQQH5()) {
    // qqH5 newAppid: 30004
    Object.assign(env, {
      fromChannel: '4',
    })
  } else {
    // 其他h5 newAppid: 30004
    Object.assign(env, {
      fromChannel: '8',
    })
  }
  if (isMiniProgram() || isAliProgram()) {
    const commonState = getApp().commonStore.state || {}
    env.openId = String(commonState.openid || '')
  }
  Object.assign(env, {
    isHitButton,
    isOpenWeb,
  })
  return env
}
/**
 * 获取系统信息
 */
export function getSystemInfo() {
  return new Promise(resolve => {
    if (isPassenger()) {
      bridge.getSystemInfo({}, res => {
        resolve(res)
      })
      return
    }
    if (__mpx_mode__ === 'wx' || __mpx_mode__ === 'ali') {
      let systemInfo
      try {
        systemInfo = mpx.getSystemInfoSync()
      } catch (e) {
        systemInfo = {}
      }
      resolve(systemInfo)
      return
    }
    resolve({})
  })
}
/**
 * 获取埋点Url
 */
export function getTrackUrl() {
  const url = window.location.href
  const newQuery = webxQuery()
  delete newQuery.cityId
  delete newQuery.city_id
  delete newQuery.cityid
  delete newQuery.lat
  delete newQuery.lng
  delete newQuery.imei
  delete newQuery.deviceid
  delete newQuery.phone
  const newUrl = build(url.split('?')[0], newQuery)
  return newUrl
}
/**
 * 三方进入套餐页，隐藏套餐详情页指定模块
 * 规则：匹配url上query参数 且 属性key值是以hide前缀的属性信息
 */
export const hideGoodDetailModule = moduleName => {
  console.log('===noduleNmae===', moduleName)
  const queryData = webxQuery() || {}
  const queryKeyArr = Object.keys(queryData) || []
  for (let i = 0; i < queryKeyArr.length; i++) {
    const item = queryKeyArr[i]
    const value = item.slice(5)
    if (item.startsWith('hide_') && value === moduleName) {
      return true
    }
  }
  return false
}
/**
 * 获取query上业务额外传递参数信息用于往其他页面进行透传
 * 规则：匹配url上query参数 且 属性key值是以ex_、exs_、exo_前缀的属性信息
 */
export function getExtraInfoOnQuery() {
  const extraInfo = {}
  const queryData = webxQuery() || {}

  const queryKeyArr = Object.keys(queryData) || []
  for (let i = 0; i < queryKeyArr.length; i++) {
    const item = queryKeyArr[i]
    if (
      queryKeyArr[i].startsWith('ex_') ||
      queryKeyArr[i].startsWith('exs_') ||
      queryKeyArr[i].startsWith('exo_')
    ) {
      extraInfo[item] = queryData[item]
    }
  }
  return extraInfo
}

/**
 * 获取query上透传的业务参数信息(埋点参数信息、传递给业务后端参数信息)
 * 规则：匹配url上query参数 且 属性key值是以ex_、exs_、exo_前缀开头的参数信息
 * ex_前缀开头参数：用于埋点、下单接口
 * exo_前缀开头参数: 只用于下单接口
 * exs_前缀开头参数：只用于上报埋点
 * 返回值: { trackExtraParams:{xxx}, bizOrderData:{xxx}}
 */
export const getBizExtraData = () => {
  const extraInfo = getExtraInfoOnQuery()
  const trackExtraParams = {}
  const bizOrderData = {}
  for (const key in extraInfo) {
    // eslint-disable-next-line no-prototype-builtins
    if (extraInfo.hasOwnProperty(key)) {
      // 获取埋点、下单接口参数
      if (key.startsWith('ex_')) {
        trackExtraParams[key.slice(3)] = extraInfo[key]
        bizOrderData[key.slice(3)] = extraInfo[key]
      }
      // 获取只用于下单接口参数
      if (key.startsWith('exo_')) {
        bizOrderData[key.slice(4)] = extraInfo[key]
      }
      // 获取只用于上报埋点参数
      if (key.startsWith('exs_')) {
        trackExtraParams[key.slice(4)] = extraInfo[key]
      }
    }
  }
  return {
    trackExtraParams, // 埋点参数
    bizOrderData, // 透传的业务后端所需参数
  }
}

/**
 * 滚动页面禁用点击事件
 * @param {*}
 */
/* eslint-disable */
export function stopTouchendPropagationAfterScroll() {
  if (__mpx_mode__ === 'web') {
    let locked = false
    window.addEventListener(
      'touchmove',
      function (ev) {
        locked ||
          ((locked = true),
          window.addEventListener('touchend', stopTouchendPropagation, true))
      },
      true
    )
    function stopTouchendPropagation(ev) {
      ev.stopPropagation()
      window.removeEventListener('touchend', stopTouchendPropagation, true)
      locked = false
    }
  }
}

export const PerfUtils = {
  getNow() {
    return window.performance && typeof window.performance.now === 'function'
      ? window.performance.now()
      : Date.now()
  },
}
// 截取对象内属性值
export const sliceHalfObject = obj => {
  if (Object.prototype.toString.call(obj) !== '[object Object]') return ''
  let res = {}
  Object.keys(obj).forEach(item => {
    res[item] = sliceHalf(obj[item])
  })
  return res
}
// 截取一半字符串
export const sliceHalf = val => {
  if (!val) return ''
  let str = String(val)
  let half = Math.ceil(str.length / 2)
  return str.slice(0, half)
}

export const xspmMap = {
  key: 'quartz-mall',
  // 已废弃，原首页准星资源位
  index: {
    b: 'index',
    banner: 'c870',
  },
  // 列表页第三方产品入口
  externalGoods: {
    b: 'index',
    c: 'c992',
  },
  // 详情页跳转去搭车/去洗车等
  orderDetail: {
    b: 'detail',
    car: 'c875', // 去搭车
  },
  saveCard: {
    b: 'index',
    c: 'c1118',
  },
}

export const getCurrencySymbols = currency => {
  if (currency === 'HKD') return 'HK$'
  return '¥'
}

export const getCurrencyText = currency => {
  if (currency === 'HKD') return 'HKD'
  return GlobalEnv.lang === EnumLang['zh-CN'] ? '元' : 'CNY'
}

export const getCreateOrderSystemParams = async () => {
  if (!is('passenger,esapp')) {
    return Promise.resolve({})
  }
  const systemInfo = await getSystemInfo()
  return systemInfo
    ? {
        suuid: systemInfo.suuid || '',
      }
    : {}
}

export const hideNativeBar = () => {
  const _pos = webxQuery().jingang && is('android')
  return !(_pos && compareVersion(GlobalEnv.appVersion, '6.7.20') < 0)
}

export const cannotUseHarmonyosShare = () => {
  if (is('passenger.harmonyos')) {
    return GlobalEnv.appVersion
      ? compareVersion(GlobalEnv.appVersion, '7.1.14') < 0
      : true
  }
  return false
}

// 下面transformUrl能覆盖到这些场景，暂不做更改
const urlMap = {
  index: 'https://page.udache.com/quartz-mall/index.html',
  goIndex: 'https://page.udache.com/quartz-mall/index.html',
  goodsDetail: 'https://prod.didi.cn/quartz-mall/goodsDetail',
  'goodsDetail.html': 'https://prod.didi.cn/quartz-mall/goodsDetail',
  goodsProcess: 'https://page.udache.com/quartz-mall/goodsProcess.html',
  orderConfirm: 'https://page.udache.com/quartz-mall/orderConfirm.html',
  orderDetail: 'https://page.udache.com/quartz-mall/orderDetail.html',
  refund: 'https://page.udache.com/quartz-mall/refund.html',
  help: 'https://page.udache.com/quartz-mall/help.html',
}

/**
 * 转换旧版URL为新版URL
 * pathname：详情页存在goodsDetail和goodsDetail.html两种情况，index存在index和goIndex两种情况，其他均为页面名称。因此需要做非常规pathname的兼容
 * @param {*} pathname 页面name
 * @returns 最终url
 */
export const transformUrl = pathname => {
  if (!urlMap[pathname]) {
    MASErrorTrackTransformUrl('pathname异常', {
      pathname,
    })
    return urlMap['index']
  }
  const oldOrigin = {
    online: 'https://page.udache.com/quartz-mall/',
    pre: 'https://pre-page.udache.com/quartz-mall/',
    offline: 'http://10.190.26.137/quartz-mall/common_offline/',
  }
  const newOrigin = {
    online: 'https://prod.didi.cn/quartz-mall/',
    pre: 'https://prod-pre.intra.xiaojukeji.com/quartz-mall/',
    offline: 'https://prod-dev.didi.cn/quartz-mall/',
  }
  const oldOriginHost = oldOrigin[process.env.BUILD_ENV] || oldOrigin.online
  const newOriginHost = newOrigin[process.env.BUILD_ENV] || newOrigin.online
  let url
  if (pathname === 'goodsDetail') {
    url = newOriginHost + pathname
  } else if (pathname === 'goodsDetail.html') {
    url = newOriginHost + 'goodsDetail'
  } else if (pathname === 'goIndex') {
    url = oldOriginHost + 'index.html'
  } else if (pathname.indexOf('.html') > -1) {
    url = oldOriginHost + pathname
  } else {
    url = oldOriginHost + pathname + '.html'
  }
  return url
}
